import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { FC } from "react";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    height = "height",
    heightMobile = "heightMobile",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.height]: number;
        [fields.heightMobile]: number;
    };
}

export interface SpacerStyles {
    spacerStyles?: InjectableCss;
}

export const spacerStyles: SpacerStyles = {
    spacerStyles: {
        css: css`
            width: 100%;
        `,
    },
};

export const Spacer: FC<OwnProps> = ({ fields: { heightMobile, height } }) => {
    const { isInShell, isEditing } = useShellContext();

    const styles = {
        css: css`
            ${spacerStyles.spacerStyles?.css || ""}

            height: ${heightMobile}px;
            background: ${isInShell && isEditing ? "lightgrey" : null};

            ${mediaQueriesBP.minMD} {
                height: ${height}px;
            }
        `,
    };

    return <StyledWrapper {...styles} />;
};

const widgetModule: WidgetModule = {
    component: Spacer,
    definition: {
        group: "Basic",
        icon: "arrows-v",
        fieldDefinitions: [
            {
                name: fields.height,
                editorTemplate: "IntegerField",
                displayName: "Space (desktop)",
                fieldType: "General",
                isRequired: true,
                sortOrder: 1,
                defaultValue: 20,
                min: 0,
            },
            {
                name: fields.heightMobile,
                editorTemplate: "IntegerField",
                displayName: "Space (mobile)",
                fieldType: "General",
                isRequired: true,
                sortOrder: 1,
                defaultValue: 20,
                min: 0,
            },
        ],
    },
};

export default widgetModule;
